import {useEffect, useState} from "preact/hooks";
import {useDispatch, useSelector} from "react-redux";
import {
    createReminder,
    fetchInformativeSession, getSessionURL, setReminderSession,
} from "../../../_rx/informative-sessions/actions";
import {AppPage} from "../../../_common/components/app-page";
import {useHistory} from "react-router";
import {F} from "../../../_common/layout";
import {t} from "../../../_i18n";
import {Fragment, h} from "preact";
import './informative-session-style.scss';
import {isMobileAgent} from "../../../_common/common";
import {RadioCheckbox, Select} from "../../../_common/forms/components/components";
import {toastService} from "../../../_services/toast-service";
import {LANG_ES, LANG_FR, LANG_IT} from "../../../constants";
import getLangByShopId from "../../../_common/utils/getLang";
import DOMPurify from "dompurify";


export const InformativeSession = (props) => {
    const dispatch = useDispatch();
    const { informativeSession, student_meta } = useSelector(state => ({
        informativeSession: state.informativeSessionReducer.informativeSession,
        student_meta: state.status.student_meta
    }));
    const history = useHistory();
    const isMobile = isMobileAgent();

    const [selectedReminder, setSelectedReminder] = useState(null);
    const [selectedOption, setSelectedOption] = useState('')
    const [loading, setLoading] = useState(true);

    const loadInformativeSession = async () => {
        try {
            const {match} = props;
            if (!match.params || !match.params.param) {
                throw new Error(t('No uid'));
            }
            const uid = match.params.param;
            setLoading(true);
            await dispatch(fetchInformativeSession(uid));
        } catch (error) {
            toastService.showToast({ message:t("Error al cargar la sesión informativa."), type:'danger' });
        } finally {
            setLoading(false);
        }
    }

    useEffect(async () => {
        await loadInformativeSession();
    }, [props.match.params.param]);

    useEffect(() => {
        if (informativeSession) {
            setSelectedReminder(informativeSession.reminder);
            setSelectedOption(informativeSession.reminder !== -1 ? informativeSession.reminder.toString() : '');
        }
    }, [informativeSession]);

    useEffect(() => {
        if (selectedReminder === -1) {
            setSelectedOption('');
        } else {
            setSelectedOption(selectedReminder);
        }
    }, [selectedReminder]);



    const reminderOptions = informativeSession?.remind_window
        ? ['', ...informativeSession.remind_window.split(',').map((option) => option.trim())]
        : [''];


    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedReminder(value);
        setSelectedOption(value);
    };

    const handleRadioChange = (value) => {
        setSelectedReminder(value);
    };

    const handleClick = async (uuid) => {
        try {
            const payload = await dispatch(getSessionURL(uuid));
            const sessionURL = payload?.url;

            if (sessionURL) {
                window.location.href = sessionURL;
            }

        } catch (error) {
            toastService.showToast({
                message: t("Error al obtener la URL de la sesión."),
                type: 'danger'
            });
        }
    };

    const handleSaveReminder = async (uuid) => {
        try {
            informativeSession.reminder = selectedReminder;
            await dispatch(createReminder(uuid, selectedReminder));
            await dispatch(fetchInformativeSession(uuid));
            toastService.showToast({ message:t("Recordatorio guardado correctamente."), type:'info' });
        } catch (error) {
            toastService.showToast({ message:t("Error al guardar el recordatorio."), type:'dange' });
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'long' };
        const langMapping = { [LANG_ES]: 'es-ES', [LANG_IT]: 'it-IT', [LANG_FR]: 'fr-FR' };
        const lang = getLangByShopId(student_meta.shop_id);
        const locale = langMapping[lang] || 'es-ES';
        const formattedDate = date.toLocaleDateString(locale, options);
        const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
        const formattedTime = date.toLocaleTimeString(locale, timeOptions);
        return `${formattedDate} ${t('formato fecha')} ${formattedTime}`;
    };

    return <AppPage
        name="Sesion Informativa"
        back={history.back}
        class="max-width-980">
        <F className="max-width-980 informative-session">
            { loading ? (
                <div></div>
            ) : (!informativeSession || !Object.keys(informativeSession).length > 0) ? (
                <div> {t('No se encontró la sesión informativa')} </div>
            ) : (
                <div className="m-l m-r">
                    <div className="back breadcrumb-item cursor-pointer m-bottom" onClick={() => history.goBack()}>
                        <i className="far fa-arrow-left p-left-half no-margin-left m-r-half" aria-hidden="true"></i>
                        {t('Volver')}
                    </div>
                    <div className='card p-all sm-p-x2-left sm-p-x2-right sm-p-x2-bottom'>
                        <h1 className={`${!isMobile ? '' : 'font-size-mobile'} bold m-bottom`}>{informativeSession.name}</h1>
                        <div key={informativeSession.uuid} className='card-dashboard-session__content'>
                            <p><strong>{t('Cuándo')}:</strong> <span> {formatDate(informativeSession.start_at)} </span></p>
                            <p className="sesion-container">
                                <strong> {t('Enlace de la sesión:')} </strong>
                                <div className="url m-l-half">
                                    <div className="container-tag" onClick={() => handleClick(informativeSession.uuid)}>
                                        <span className="with-text-decoration">{t('Ir al directo')}</span>
                                        {!!informativeSession.is_running &&
                                            <Fragment>
                                                <p className="tag">
                                                    <i className="fas fa-play-circle p-left-half p-right-half"
                                                       aria-hidden="true"></i>
                                                    <span className="direct">{t('En directo')}</span>
                                                </p>
                                            </Fragment>
                                        }
                                    </div>
                                </div>
                            </p>
                            {(!informativeSession.is_running && !informativeSession.is_past) &&
                                <p className="reminder-container alert m-top">
                                    <strong> {t('Recordatorio:')} </strong>
                                    <div className="radio-select-option">
                                        <p className="grey no-margin-top m-bottom-half"> {t('Selecciona una opción...')} </p>
                                        <RadioCheckbox
                                            label={t('No enviar recordatorio')}
                                            type='radio'
                                            onChange={() => handleRadioChange(-1)}
                                            checked={selectedReminder === -1}
                                        />
                                        <RadioCheckbox
                                            label={t('Enviar un email recordatorio antes de la sesión')}
                                            type='radio'
                                            onChange={() => handleRadioChange(selectedOption)}
                                            checked={selectedReminder !== -1}
                                        />
                                        <Select
                                            onChange={handleSelectChange}
                                            noEmptyOption={true}
                                            value={selectedOption}
                                            options={reminderOptions.map((element, index) => ({
                                                key: element,
                                                id: index,
                                                name: element
                                            }))}
                                            disabled={selectedReminder === -1}
                                        />

                                        <button className={'btn btn-ghost m-top'}
                                                onClick={() => handleSaveReminder(informativeSession.uuid)}
                                                disabled={selectedOption === '' && selectedReminder !== -1}>
                                            <span
                                                className={`${!isMobile ? '' : 'font-size-mobile'}`}>{t('guardar cambios')}</span>
                                        </button>
                                    </div>
                                </p>
                            }
                            {informativeSession.details &&
                                <Fragment>
                                    <hr className="separator-xs"/>
                                    <div className="description" dangerouslySetInnerHTML={{__html: treatBody(informativeSession.details)}}/>
                                </Fragment>
                            }
                        </div>
                    </div>
                </div>
            )}
        </F>
    </AppPage>
}

const treatBody = (body = '') => {
    const cleaned = DOMPurify.sanitize(
      body
        .replace(/<p>\s*<\/p>/gi, '<br>')
        .replace(/&nbsp;/g, ' '),
      {
          ALLOWED_TAGS: ['h1', 'h2', 'b', 'i', 'strong', 's', 'em', 'u', 'a', 'p', 'br', 'ul', 'ol', 'li', 'img', 'iframe', 'span', 'blockquote'],
          ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'width', 'height', 'frameborder', 'allowfullscreen', 'class', 'style', 'target'],
      }
    );
    return `<div class="inner-body-open-day">${cleaned}</div>`;
};
